import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getXmlFormats } from "./actions";

export const xmlFormatsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = xmlFormatsEntityAdapter.getInitialState({});

export const xmlFormatsSlice = createSlice({
  name: "xmlFormats",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getXmlFormats.fulfilled, (state, action) => {
      if (action.payload.status) {
        xmlFormatsEntityAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export default xmlFormatsSlice.reducer;
